import { Label } from "../ui/label";

export const Section = ({ id, title, subtitle, accent = "bg-tangerine", badge, testid, children }) => (
  <div id={id} data-testid={testid} className="relative overflow-hidden rounded-lg border border-border bg-bone">
    <span className={`absolute inset-y-0 left-0 w-1.5 ${accent}`} />
    <div className="p-6 pl-8 lg:p-9 lg:pl-11">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-3xl leading-tight text-ink">{title}</h3>
          <p className="mt-1 text-[13px] text-olive">{subtitle}</p>
        </div>
        {badge}
      </div>
      <div className="mt-6">{children}</div>
    </div>
  </div>
);

export const Field = ({ label, counter, hint, optional, children }) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between gap-3">
      <Label className="text-[13px] font-medium text-ink">
        {label}
        {optional && <span className="ml-1.5 text-[13px] font-normal text-olive">optional</span>}
      </Label>
      {counter != null && <span className="text-[13px] text-olive">{counter}</span>}
    </div>
    {children}
    {hint && <p className="text-[13px] italic text-olive/80">{hint}</p>}
  </div>
);

export const OptionalTag = () => (
  <span className="rounded-full bg-sand px-2.5 py-1 text-[13px] font-semibold uppercase tracking-[0.18em] text-olive ring-1 ring-inset ring-ink/10">
    Optional
  </span>
);

const STATUS = {
  draft: { bg: "bg-yellow/25", fg: "text-ink", label: "Draft" },
  pending_review: { bg: "bg-cobalt/12", fg: "text-cobalt", label: "In review" },
  live: { bg: "bg-grass/12", fg: "text-grass", label: "Live" },
  paused: { bg: "bg-yellow/20", fg: "text-ink", label: "Paused" },
  closed: { bg: "bg-border", fg: "text-olive", label: "Closed" },
  rejected: { bg: "bg-scarlet/12", fg: "text-scarlet", label: "Needs edits" },
};

export const StatusPill = ({ status }) => {
  const m = STATUS[status] || STATUS.draft;
  return (
    <span
      data-testid="builder-status-pill"
      className={`inline-flex items-center gap-1.5 rounded-full ${m.bg} px-3 py-1 text-[13px] font-semibold uppercase tracking-[0.18em] ${m.fg}`}
    >
      {m.label}
    </span>
  );
};

export const fileSrc = (fileId) => {
  if (!fileId) return null;
  const t = typeof window !== "undefined" ? localStorage.getItem("mra_jwt") : null;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${fileId}${t ? `?auth=${t}` : ""}`;
};
